// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"225":"template","272":"order-form"}[chunkId] || chunkId) + "." + {"225":"45c4910a","272":"138fa0cb","413":"0e0417ac"}[chunkId] + ".css";
};